(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
	class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector(
          'input[name="locale_code"], input[name="country_code"]'
        ),
        button: this.querySelector("button"),
        panel: this.querySelector("ul"),
      };

      this.handleDocumentClick = this.handleDocumentClick.bind(this);
      this.elements.button.addEventListener("click", this.togglePanel.bind(this));
      this.addEventListener("keydown", this.onEscapePress.bind(this));

      this.querySelectorAll("a").forEach((item) =>
        item.addEventListener("click", this.onItemClick.bind(this))
      );
    }

    connectedCallback() {
      document.addEventListener("click", this.handleDocumentClick);
    }

    disconnectedCallback() {
      document.removeEventListener("click", this.handleDocumentClick);
    }

    handleDocumentClick(event) {
      if (!this.contains(event.target)) {
        this.hidePanel();
      }
    }

    hidePanel() {
      this.elements.button.setAttribute("aria-expanded", "false");
      this.elements.panel.setAttribute("hidden", true);
    }

    showPanel() {
      this.elements.button.setAttribute("aria-expanded", "true");
      this.elements.panel.removeAttribute("hidden");
    }

    togglePanel() {
      if (this.elements.button.getAttribute("aria-expanded") === "true") {
        this.hidePanel();
      } else {
        this.showPanel();
      }
    }

    onEscapePress(event) {
      if (event.key === "Escape") {
        this.hidePanel();
      }
    }

    onItemClick(event) {
      event.preventDefault();
      this.elements.input.value = event.currentTarget.dataset.value;
      this.querySelector("form")?.submit();
      this.hidePanel();
    }
  }

  if (!customElements.get("localization-form")) {
    customElements.define("localization-form", LocalizationForm);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
	class StickyHeader extends HTMLElement {
		constructor() {
			super();
		}

		connectedCallback() {
			this.header = document.querySelector('.shopify-section-header');
			this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
			this.headerBounds = {};
			this.currentScrollTop = 0;
			this.preventReveal = false;
			this.predictiveSearch = this.querySelector('predictive-search');

			this.onScrollHandler = this.onScroll.bind(this);
			this.hideHeaderOnScrollUp = () => this.preventReveal = true;

			this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
			window.addEventListener('scroll', this.onScrollHandler, false);

			this.createObserver();

			if (this.headerIsAlwaysSticky) this.reveal;
		}

		disconnectedCallback() {
			this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
			window.removeEventListener('scroll', this.onScrollHandler);
		}

		createObserver() {
			let observer = new IntersectionObserver((entries, observer) => {
			this.headerBounds = entries[0].intersectionRect;
				observer.disconnect();
			});

			if (this.header) {
				observer.observe(this.header);
			}
		}

		onScroll() {
			const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

			if (this.headerIsAlwaysSticky && scrollTop > this.header.offsetHeight + 1) {
				this.header.classList.add('shopify-section-header-sticky','shopify-section-header-always-sticky');
			};

			if (this.headerIsAlwaysSticky && scrollTop < this.header.offsetHeight) {
				this.header.classList.remove('shopify-section-header-sticky');
			};

			if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
				if (this.predictiveSearch && this.predictiveSearch.onFocusOut) {
					this.predictiveSearch.onFocusOut();
					this.predictiveSearch.onBlur();
				}
				if (this.preventHide) return;
				requestAnimationFrame(this.hide.bind(this));
			} else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
				if (!this.preventReveal) {
					requestAnimationFrame(this.reveal.bind(this));
				} else {
					window.clearTimeout(this.isScrolling);

					this.isScrolling = setTimeout(() => {
					this.preventReveal = false;
				}, 66);

				requestAnimationFrame(this.hide.bind(this));
				}
			} else if (scrollTop <= this.headerBounds.top) {
				requestAnimationFrame(this.reset.bind(this));
			}

			this.currentScrollTop = scrollTop;
		}

		hide() {
			if (this.headerIsAlwaysSticky) return;
			this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
			this.closeMenuDisclosure();
		}

		reveal() {
			if (this.headerIsAlwaysSticky) return;
			this.header.classList.add('shopify-section-header-sticky', 'animate');
			this.header.classList.remove('shopify-section-header-hidden');
		}

		reset() {
			if (this.headerIsAlwaysSticky) return;
			this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
		}

		closeMenuDisclosure() {
			this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
			if (this.disclosures) {
				this.disclosures.forEach(disclosure => disclosure.close());
			}
		}
	}

	customElements.define('sticky-header', StickyHeader);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener(
        'change',
        debounce((event) => {
          const body = JSON.stringify({ note: event.target.value });
          fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
        }, 300)
      );
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    

  class ProductModal extends ModalDialog {

    constructor() {
      super();
    }

    hide() {
      super.hide();
      window.pauseAllMedia();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {

      this.querySelectorAll(
        `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
      ).forEach((element) => {
        element.classList.remove('active');
      });

      const activeMedia = this.querySelector(
        `[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`
      );

      const activeMediaTemplate = activeMedia.querySelector('template');

      const activeMediaContent = activeMediaTemplate
        ? activeMediaTemplate.content
        : null;

      activeMedia.classList.add('active');

      activeMedia.scrollIntoView();

      if (
        activeMedia.nodeName == 'DEFERRED-MEDIA' &&
        activeMediaContent &&
        activeMediaContent.querySelector('.js-youtube')
      ) {
        activeMedia.loadContent();
      }
    }
  }


  class RelatedProduct extends HTMLElement {

    constructor() {
      super();

      const handleIntersection = (entries, observer) => {

        if (!entries[0].isIntersecting) return;

        observer.unobserve(this);

        fetch(this.dataset.url)
          .then((response) => response.text())
          .then((text) => {

            const html = document.createElement('div');

            html.innerHTML = text;

            const related = html.querySelector('.related-product');

            if (related && related.innerHTML.trim().length) {
              this.innerHTML = related.innerHTML;
            }

            $('.product-description-more').click(function (e) {

              e.preventDefault();

              $(this)
                .closest('.product-description-short')
                .next()
                .show();

              $(this)
                .closest('.product-description-short')
                .hide();
            });

            $('.product-description-less').click(function (e) {

              e.preventDefault();

              $(this)
                .closest('.product-description-full')
                .prev()
                .show();

              $(this)
                .closest('.product-description-full')
                .hide();
            });

          })
          .catch((e) => {
            console.error(e);
          });
      };

      new IntersectionObserver(
        handleIntersection.bind(this),
        {
          rootMargin: '0px 0px 200px 0px'
        }
      ).observe(this);
    }
  }


  class RelatedSlider extends HTMLElement {

    constructor() {
      super();

      const handleIntersection = (entries, observer) => {

        if (!entries[0].isIntersecting) return;

        observer.unobserve(this);

        fetch(this.dataset.url)
          .then((response) => response.text())
          .then((text) => {

            const html = document.createElement('div');

            html.innerHTML = text;

            const relatedSlider = html.querySelector(
              `related-slider[data-id="${this.getAttribute('data-id')}"]`
            );

            if (
              relatedSlider &&
              relatedSlider.innerHTML.trim().length
            ) {
              this.innerHTML = relatedSlider.innerHTML;
            }

            const slider = this.querySelector(
              '.related-slider__list'
            );

            const prevBtn = this.querySelector(
              '.related-slider__button-prev'
            );

            const nextBtn = this.querySelector(
              '.related-slider__button-next'
            );

            const twoColumns = this.querySelector(
              '.swiper-wrapper-2-mobile'
            );

            if (
              twoColumns &&
              document.querySelector('.related-slider__list')
            ) {

              const productSlider = new Swiper(slider, {

                slidesPerView: 2,
                spaceBetween: 10,

                navigation: {
                  nextEl: nextBtn,
                  prevEl: prevBtn,
                },

                simulateTouch: true,
                allowTouchMove: true,
                watchSlidesProgress: true,
                preventInteractionOnTransition: true,

                mousewheel: {
                  forceToAxis: true,
                },

                breakpoints: {

                  750: {
                    slidesPerView: 2,
                  },

                  1200: {
                    slidesPerView: 3,
                  },
                },
              });

            } else if (
              document.querySelector('.related-slider__list')
            ) {

              const productSlider = new Swiper(slider, {

                slidesPerView: 1,
                spaceBetween: 10,

                navigation: {
                  nextEl: nextBtn,
                  prevEl: prevBtn,
                },

                simulateTouch: true,
                allowTouchMove: true,
                watchSlidesProgress: true,
                preventInteractionOnTransition: true,

                mousewheel: {
                  forceToAxis: true,
                },

                breakpoints: {

                  750: {
                    slidesPerView: 2,
                  },

                  1200: {
                    slidesPerView: 3,
                  },
                },
              });
            }


            const generateSrcset = (
              image,
              widths = []
            ) => {

              const imageUrl = new URL(image['src']);

              return widths
                .filter((width) => width <= image['width'])
                .map((width) => {

                  imageUrl.searchParams.set(
                    'width',
                    width.toString()
                  );

                  return `${imageUrl.href} ${width}w`;
                })
                .join(', ');
            };


            const createImageElement = (
              image,
              classes,
              sizes,
              productTitle
            ) => {

              const previewImage = image['preview_image'];

              const newImage = new Image(
                previewImage['width'],
                previewImage['height']
              );

              newImage.className = classes;
              newImage.alt = image['alt'] || productTitle;
              newImage.sizes = sizes;
              newImage.src = previewImage['src'];

              newImage.srcset = generateSrcset(
                previewImage,
                [
                  165,
                  360,
                  533,
                  720,
                  940,
                  1066
                ]
              );

              newImage.loading = 'lazy';

              return newImage;
            };


            const checkSwatches = () => {

              document
                .querySelectorAll('.js-color-swatches-wrapper')
                .forEach((wrapper) => {

                  wrapper
                    .querySelectorAll('.js-color-swatches input')
                    .forEach((input) => {

                      input.addEventListener(
                        'click',
                        (event) => {

                          const primaryImage = wrapper.querySelector(
                            '.media--first'
                          );

                          const secondaryImage = wrapper.querySelector(
                            '.media--second'
                          );

                          const handleProduct = wrapper.dataset.product;

                          if (
                            event.currentTarget.checked &&
                            primaryImage
                          ) {

                            wrapper
                              .querySelector('.js-color-swatches-link')
                              .setAttribute(
                                'href',
                                event.currentTarget.dataset.variantLink
                              );

                            if (
                              wrapper.querySelector(
                                '.card__add-to-cart button[name="add"]'
                              )
                            ) {

                              wrapper
                                .querySelector(
                                  '.card__add-to-cart button[name="add"]'
                                )
                                .setAttribute(
                                  'aria-disabled',
                                  false
                                );

                              wrapper
                                .querySelector(
                                  '.card__add-to-cart button[name="add"] > span'
                                )
                                .classList.remove('hidden');

                              wrapper
                                .querySelector(
                                  '.card__add-to-cart button[name="add"] .sold-out-message'
                                )
                                .classList.add('hidden');

                              wrapper.querySelector(
                                '.card__add-to-cart input[name="id"]'
                              ).value =
                                event.currentTarget.dataset.variantId;
                            }

                            const currentColor =
                              event.currentTarget.value;

                            jQuery.getJSON(
                              window.Shopify.routes.root +
                                `products/${handleProduct}.js`,
                              function (product) {

                                const variant =
                                  product.variants.filter(
                                    (item) =>
                                      item.featured_media != null &&
                                      item.options.includes(currentColor)
                                  )[0];

                                if (variant) {

                                  const newPrimaryImage =
                                    createImageElement(
                                      variant['featured_media'],
                                      primaryImage.className,
                                      primaryImage.sizes,
                                      product.title
                                    );

                                  if (
                                    newPrimaryImage.src !==
                                    primaryImage.src
                                  ) {

                                    let flag = false;

                                    if (secondaryImage) {

                                      const secondaryImagePathname =
                                        new URL(
                                          secondaryImage.src
                                        ).pathname;

                                      const newPrimaryImagePathname =
                                        new URL(
                                          newPrimaryImage.src
                                        ).pathname;

                                      if (
                                        secondaryImagePathname ==
                                        newPrimaryImagePathname
                                      ) {

                                        primaryImage.remove();

                                        secondaryImage.classList.remove(
                                          'media--second'
                                        );

                                        secondaryImage.classList.add(
                                          'media--first'
                                        );

                                        flag = true;
                                      }
                                    }

                                    if (flag == false) {

                                      primaryImage.animate(
                                        {
                                          opacity: [1, 0]
                                        },
                                        {
                                          duration: 200,
                                          easing: 'ease-in',
                                          fill: 'forwards'
                                        }
                                      ).finished;

                                      setTimeout(
                                        function () {

                                          primaryImage.replaceWith(
                                            newPrimaryImage
                                          );

                                          newPrimaryImage.animate(
                                            {
                                              opacity: [0, 1]
                                            },
                                            {
                                              duration: 200,
                                              easing: 'ease-in'
                                            }
                                          );

                                          if (secondaryImage) {
                                            secondaryImage.remove();
                                          }

                                        },
                                        200
                                      );
                                    }
                                  }
                                }
                              }
                            );
                          }
                        }
                      );
                    });
                });
            };

            checkSwatches();

          })
          .catch((e) => {
            console.error(e);
          });
      };


      new IntersectionObserver(
        handleIntersection.bind(this),
        {
          rootMargin: '0px 0px 200px 0px',
        }
      ).observe(this);
    }
  }


  customElements.define(
    'product-modal',
    ProductModal
  );

  customElements.define(
    'related-product',
    RelatedProduct
  );

  customElements.define(
    'related-slider',
    RelatedSlider
  );


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then((response) => response.text())
          .then((text) => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            /* Color swatches */
            const generateSrcset = (image, widths = []) => {
              const imageUrl = new URL(image['src']);
              return widths
                .filter((width) => width <= image['width'])
                .map((width) => {
                  imageUrl.searchParams.set('width', width.toString());
                  return `${imageUrl.href} ${width}w`;
                })
                .join(', ');
            };

            const createImageElement = (image, classes, sizes, productTitle) => {
              const previewImage = image['preview_image'];
              const newImage = new Image(previewImage['width'], previewImage['height']);
              newImage.className = classes;
              newImage.alt = image['alt'] || productTitle;
              newImage.sizes = sizes;
              newImage.src = previewImage['src'];
              newImage.srcset = generateSrcset(previewImage, [165, 360, 533, 720, 940, 1066]);
              newImage.loading = 'lazy';
              return newImage;
            };

            const checkSwatches = () => {
              document.querySelectorAll('.js-color-swatches-wrapper').forEach(wrapper => {
                wrapper.querySelectorAll('.js-color-swatches input').forEach(input => {
                  input.addEventListener('click', (event) => {
                    const primaryImage = wrapper.querySelector(".media--first");
                    const secondaryImage = wrapper.querySelector(".media--second");
                    const handleProduct = wrapper.dataset.product;
                    
                    if (event.currentTarget.checked && primaryImage) {
                      wrapper.querySelector('.js-color-swatches-link').setAttribute('href', event.currentTarget.dataset.variantLink);
                      if (wrapper.querySelector('.card__add-to-cart button[name="add"]')) {
                        wrapper.querySelector('.card__add-to-cart button[name="add"]').setAttribute('aria-disabled', false);
                        wrapper.querySelector('.card__add-to-cart button[name="add"] > span').classList.remove('hidden');
                        wrapper.querySelector('.card__add-to-cart button[name="add"] .sold-out-message').classList.add('hidden');
                        wrapper.querySelector('.card__add-to-cart input[name="id"]').value = event.currentTarget.dataset.variantId;
                      }
                      
                      const currentColor = event.currentTarget.value;

                      jQuery.getJSON(window.Shopify.routes.root + `products/${handleProduct}.js`, function(product) {
                        const variant = product.variants.filter(item => item.featured_media != null && item.options.includes(currentColor))[0];

                        if (variant) {
                          const newPrimaryImage = createImageElement(variant["featured_media"], primaryImage.className, primaryImage.sizes, product.title);
                          
                          if (newPrimaryImage.src !== primaryImage.src) {
                            let flag = false;
                            if (secondaryImage) {
                              const secondaryImagePathname = new URL(secondaryImage.src).pathname;
                              const newPrimaryImagePathname = new URL(newPrimaryImage.src).pathname;

                              if (secondaryImagePathname == newPrimaryImagePathname) {
                                primaryImage.remove();
                                secondaryImage.classList.remove('media--second');
                                secondaryImage.classList.add('media--first');
                                flag = true;
                              } 
                            }
                            if (flag == false) {
                              primaryImage.animate({ opacity: [1, 0] }, { duration: 200, easing: "ease-in", fill: "forwards" }).finished;
                              setTimeout(function(){
                                primaryImage.replaceWith(newPrimaryImage);
                                newPrimaryImage.animate({ opacity: [0, 1] }, { duration: 200, easing: "ease-in" });
                                if (secondaryImage) {
                                  secondaryImage.remove();                                    
                                }
                              }, 200);
                            }
                          }
                        }
                      });
                    }
                  })
                })
              })
            }

            checkSwatches();
          })
          .catch((e) => {
            console.error(e);
          });
      };

      new IntersectionObserver(handleIntersection.bind(this), {
        rootMargin: '0px 0px 200px 0px',
      }).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
